// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__izzbV","signatureButtonsRight":"ModalSign_signatureButtonsRight__2h_2l"};